import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'angular-highcharts';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';


import { MaterialModule } from 'src/app/shared/material/material.module';


import { AllReportsComponent } from './all-reports.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { AllReportsRoutingModule } from './all-reports-routing.module';
import { ChSkeletonComponent } from '../../shared/ch-skeleton/ch-skeleton.component';

@NgModule({
  declarations: [
    AllReportsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    CustomDatePickerModule,
    CustomInputModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    ChartModule,
    AllReportsRoutingModule,
    ChSkeletonComponent
  ],
  exports: [
    AllReportsComponent
  ]
})
export class AllReportsModule { }